
// API 请求前缀，日后改成分布式方便点
  const  API_URL = "/api";


 const  acconut_status_option = [
    { text: "正常", value: "1" },
    { text: "欠费", value: "2" },
    { text: "暂停", value: "3" }
  ]

const  constant ={
   platform:{
     talkie:"talkie",
     control: "control"
   }
}

  export default {
      acconut_status_option,
      API_URL,
      constant
  }



// WEBPACK FOOTER //
// ./src/utils/constant.js